import CreditsPaymentDetailsMobile from './CreditsPaymentDetailsMobile';
import { connect } from 'react-redux';
import { creditsActions } from 'src/store/modules/credits';

const mapDispatchToProps = (dispatch: any) => ({
  disposeCredit: (databaseId: number, taker: string, note: string) => {
    dispatch(creditsActions.disposeCredit(databaseId, taker, note));
  }
});

export default connect(
  undefined,
  mapDispatchToProps
)(CreditsPaymentDetailsMobile);
